<div class="form-group" *ngIf="checkViewMode('edit')">
  <label for="">
    <span class="red-text">{{ getTitle() }} </span>
    <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
    <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info"
    [popover]="getOptionByKey(attribute,'tooltip')"
    placement="right"
    container="body"
    triggers="mouseenter:mouseleave">
      <i class="fa fa-question-circle"></i>
    </div>
  </label>
  <ng-select
    [id]="getOptionByKey(attribute,'identifier')"
    [class.has-error]="attribute.hasError"
    [items]="users"
    [disabled]="getOptionByKey(attribute,'disabled')"
    [required]="getOptionByKey(attribute,'required')"
    bindValue="id"
    bindLabel="name"
    [tabindex]="getOptionByKey(attribute,'tabIndex')"
    placeholder="{{ placeholder }}"
    (change)="changedSelect()"
    [(ngModel)]="attribute.value">
  </ng-select>
</div>
<div class="" *ngIf="checkViewMode('view')">
  <p><span>{{ getTitle() }}: </span> {{ getFullNameByUserName(attribute.value) }}</p>
</div>
